export enum Component_Id {
  Duration = '9c536820-daee-481e-bf8c-b96b1f5ed4bd',
  Link = '7dddad5b-4c8d-4203-994f-ef5c02e6f372',
  subTask = 'bdc83ce-75da-483a-b23d-3e72ce191856',
  WetRate = '0966ca7e-eeef-4166-9859-a14f3e88b801',
  UnitQuantity = '4ebb0189-f4ab-4a74-9b82-5ed18a17a0df',
}
